<template>
  <div class="article-content" v-html="props.content"></div>
  <el-card
    v-if="props.attachmentFileList && props.attachmentFileList.length"
    class="attachments-card"
  >
    <zc-description label="附件" suffix="：">
      <el-row v-for="item in props.attachmentFileList" :key="item.id">
        <el-text>
          <a
            class="attachment-operation"
            target="_blank"
            :href="item.fileFullPath"
          >
            {{ item.attachmentName }}</a
          >
        </el-text>
      </el-row>
    </zc-description>
  </el-card>
</template>

<script setup>
// #region 引用

// #endregion

// #region props/emit

const props = defineProps({
  content: String,
  attachmentFileList: Array,
});

// #endregion

// #region 变量/常量

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

// #endregion
</script>

<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

.article-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.attachment-operation {
  color: $website-primary;
  transition: all $website-duration-slow $website-ease-in-out;
}

/* PC端样式 */
@include pc {
  .article-content {
    :deep(img) {
      display: inline-block;
      width: 100%;
      border-radius: $website-radius-md;
      transition: transform $website-duration-slow $website-ease-in-out;

      &:hover {
        transform: scale(1.02);
      }
    }
  }

  .attachments-card {
    margin-top: 16px;
    border-radius: $website-radius-md;
    transition: all $website-duration-slow $website-ease-in-out;

    &:hover {
      box-shadow: $website-shadow-md;
    }
  }

  .attachment-operation {
    &:hover {
      color: $website-primary-light;
      text-decoration: underline;
    }
  }
}

/* 移动端样式 */
@include mobile {
  .article-content {
    :deep(img) {
      display: inline-block;
      max-width: 100%;
      border-radius: 3vw;
      transition: transform $website-duration-normal $website-ease-out,
        filter $website-duration-normal $website-ease-out;

      &:active {
        transform: scale(0.98);
        filter: brightness(0.95);
      }
    }

    :deep(a) {
      @include underline-effect($website-primary-light);
      color: $website-primary;
      text-decoration: none;
      transition: color $website-duration-normal $website-ease-out;

      &:active {
        color: $website-primary-light;
      }
    }

    :deep(p) {
      font-size: 4vw;
    }

    :deep(.el-text) {
      font-size: 4vw;
    }

    :deep(.zc-description-container .title) {
      font-size: 4vw;
    }
  }

  .attachments-card {
    min-height: 6vh;
    padding: 2vw 0;
    margin-top: 4vw;
    line-height: 2;
    border-radius: 3vw;
    transition: all $website-duration-normal $website-ease-in-out;

    &:active {
      transform: scale(0.98);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }
  }

  .attachment-operation {
    position: relative;
    transition: all $website-duration-normal $website-ease-out;

    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 0;
      height: 1px;
      background: $website-primary-light;
      transition: width $website-duration-normal $website-ease-out;
    }

    &:active {
      opacity: 0.9;
      transform: translateX(1vw);

      &::after {
        width: 100%;
      }
    }
  }
}
</style>
